import React, { lazy, Suspense, useEffect } from 'react';
import { Card, CardContent, CardHeader } from '../../../components/ui/card';
import TableSkeleton from '../../../components/TableSkeleton';
import Spinner from '../../../components/Spinner';
import FiltersSkeleton from '../../../components/FiltersSkeleton';
import { useRoles } from '../../../contexts/RoleContext';

const Filters = lazy(() => import('./Filters'));
const TanstackTable = lazy(() => import('../../../components/TanstackTable'));
const Add = lazy(() => import('./Add'));
const Update = lazy(() => import('./Update'));
const ConfirmDialog = lazy(() => import('../../../components/ConfirmDialog'));


const Manage = () => {
    const {
        table,
        columns,
        loading,
        roles,
        pagination,
        handlePageChange,
        updateData,
        openUpdateModal,
        setOpenUpdateModal,
        showDeleteConfirmationDialog,
        handleCloseModal,
        handleDelete,
    } = useRoles();


    useEffect(() => {
        if (updateData.id !== "") { 
            setOpenUpdateModal(true);
        }
    }, [updateData, setOpenUpdateModal]);

    return (
        <>
            <Card className="w-full mb-2 overflow-hidden">
                <CardHeader>Roles</CardHeader>
                <CardContent>
                    <div>
                        <div className="flex justify-between mb-4 hidden md:flex">
                            <Suspense fallback={<FiltersSkeleton/>}>
                                <Filters />
                            </Suspense>
                            <div className="flex items-start mb-4">
                                {/* <Suspense fallback={<Skeleton className="w-5 h-5"/>}>
                                    <TanstackColumns table={table} data={roles} columns={columns} />
                                </Suspense> */}
                                <Suspense fallback={<Spinner container="h-8 w-[130px]"/>}>
                                    <Add />
                                </Suspense>
                            </div>
                        </div>
                        <div className="flex flex-col gap-4 justify-between mb-4 md:hidden">
                            <Suspense fallback={<Spinner container="h-8 w-full"/>}>
                                <Add />
                            </Suspense>
                            <Suspense fallback={<FiltersSkeleton/>}>
                                <Filters />
                            </Suspense>
                        </div>
                    </div>
                    <Suspense fallback={<TableSkeleton columns={5} rows={5} headers={["#", "Code", "Title", "Status", "Actions"]}/>}> 
                        <TanstackTable
                            loading={loading}
                            table={table}
                            data={roles || []}
                            columns={columns}
                            pagination={pagination}
                            handlePageChange={handlePageChange}
                        />
                    </Suspense>
                </CardContent>
            </Card>
            <Suspense fallback={<Spinner/>}>
                <Update
                    data={updateData}
                    open={openUpdateModal}
                    handleClose={e => handleCloseModal('update')}
                />
            </Suspense>
            <Suspense fallback={<Spinner/>}>
                <ConfirmDialog
                    open={showDeleteConfirmationDialog}
                    confirmAction={handleDelete}
                    handleClose={e => handleCloseModal('delete')}
                    actionText="Delete"
                    descriptionText="Are you sure you want to delete this Role?"
                />
            </Suspense>
        </>
    );
};

export default Manage;
